import { Pipe, PipeTransform } from '@angular/core';

/**
 * Renders a percentage value as `21%`, or a fallback (default `-`) when there is no value.
 * Unlike a truthiness check, 0 is a real value and renders as `0%`.
 */
@Pipe({
  name: 'percentage',
  standalone: true,
})
export class PercentagePipe implements PipeTransform {
  transform(value: number | string | null | undefined, fallback = '-'): string {
    if (value === null || value === undefined || value === '') return fallback;
    return `${value}%`;
  }
}
